import { apiClient } from '@api';
import { PatientProfile } from '@qmd-types/patient';

export async function fetchProfile(): Promise<PatientProfile> {
  const { data } = await apiClient.get<PatientProfile>('/api/v1/profile');

  return data;
}
